<template>
  <button
    class="frisbuy-button-hidden-pages"
    :class="[`frisbuy-button-hidden-pages--${props.direction}`]"
    @click="clickHandler"
    @mouseover="isHover = true"
    @mouseleave="isHover = false"
  >
    <svg
      v-if="isHover"
      class="frisbuy-button-hidden-pages__arrow"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
    >
      <path
        fill="currentColor"
        d="M452.864 149.312a29.12 29.12 0 0 1 41.728.064L826.24 489.664a32 32 0 0 1 0 44.672L494.592 874.624a29.12 29.12 0 0 1-41.728 0 30.592 30.592 0 0 1 0-42.752L764.736 512 452.864 192a30.592 30.592 0 0 1 0-42.688m-256 0a29.12 29.12 0 0 1 41.728.064L570.24 489.664a32 32 0 0 1 0 44.672L238.592 874.624a29.12 29.12 0 0 1-41.728 0 30.592 30.592 0 0 1 0-42.752L508.736 512 196.864 192a30.592 30.592 0 0 1 0-42.688z"
      ></path>
    </svg>
    <svg
      v-else
      class="frisbuy-button-hidden-pages__dots"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
    >
      <path
        :fill="props.fillColor || 'currentColor'"
        d="M176 416a112 112 0 1 1 0 224 112 112 0 0 1 0-224m336 0a112 112 0 1 1 0 224 112 112 0 0 1 0-224m336 0a112 112 0 1 1 0 224 112 112 0 0 1 0-224"
      ></path>
    </svg>
  </button>
</template>

<script setup lang="ts">
import { ref } from "vue";

const props = withDefaults(
  defineProps<{
    direction?: "left" | "right";
    fillColor?: string;
  }>(),
  {
    direction: "right",
    fillColor: "#606266",
  }
);

const emit = defineEmits(["click"]);

function clickHandler() {
  setTimeout(() => {
    isHover.value = false; // NOTE: fix mobile touch
  }, 45); // NOTE: delay only for soft click. Just UX

  emit("click");
}

const isHover = ref<boolean>(false);
</script>

<style scoped lang="scss">
.frisbuy-button-hidden-pages {
  width: 32px;
  height: 32px;

  background-color: transparent;
  border: none;

  cursor: pointer;

  svg {
    display: block;
    margin: auto;
  }

  &--left {
    left: 0;

    .frisbuy-button-hidden-pages__arrow {
      scale: -1 1;
    }
  }

  &--right {
    right: 0;
  }
}
</style>
